import { render, staticRenderFns } from "./UiMobileSelect.vue?vue&type=template&id=095b3ef7&"
import script from "./UiMobileSelect.vue?vue&type=script&lang=js&"
export * from "./UiMobileSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports